export const shopcategory = [
    "General & Grocery Stores",
    "Brand Stores",
    "Clothing & Fashion",
    "Electronics & Appliances",
    "Home & Furnishing",
    "Cosmetic & Beauty Products",
    "Jewelry & Accessories",
    "Medical & health Care Store",
    "Books & Stationery",
    "Automobile & Spair Parts",
    "Toys & Baby Products",
    "Sports & Outdoor",
    "Hardware & Building Materials",
    "Haircut",
    "Pet Supplies",
    "Footwear & Accessories",
    "Gifts & Flower Shops",
    "Restaurants & Food Services",
    "Entertainment & Hobbies",
    "Repair & Service Shops",
    "Handicrafts & Traditional Goods",
    "Eco-friendly & Sustainable Products",
    "Mobile Phones & Gadgets Shop",
    "Wedding & Event Planning",
    "Festivals & Seasonal Shops",
    "Travel Accessories",
    "Luxury Goods",
    "Religious & Spiritual Goods",
    "Green Energy & Solar Products",
    "Education & Coaching Centers",
    "Art & Cultural Stores",
    "Alcohol & Beverages",
    "Local Markets & Bazaars",
    "Lokvani Kendra",
    "Fruit Shop",
    "Vegetables Shop"
  ];